import { UserDashboard } from '../../components/dashboard/UserDashboard';

export default function OperationsDashboard(): React.JSX.Element {
  return <UserDashboard role="operations" title="Operations dashboard" description="Internal operations workspace." />;
}
